module.exports = __webpack_public_path__ + "static/media/port.9eb75227.svg";